<template>
	<div :class="computedClass">
		<div class="mobile-sidebar__header">
			<div class="mobile-sidebar__arrow mobile-sidebar__arrow--env" @click="handleSidebar()">
				<SidebarArrow />
			</div>
		</div>
		<div class="mobile-sidebar__content">
			<MenuContent :isMobile="true" @handleSidebar="handleSidebar" />
		</div>
		<div class="mobile-sidebar__profile">
			<UserInfo :isMobile="true" />
		</div>
	</div>
</template>

<script>
import MenuLogo from '@/components/shared/Icons/MenuLogo.vue';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import UserInfo from '@/components/shared/UserInfo/UserInfo.vue';
import MenuContent from '@/components/shared/MenuContent/MenuContent.vue';

export default {
	name: 'MobileSidebar',
	props: {
		isOpen: {
			required: true,
		},
	},
	components: { MenuLogo, SidebarArrow, UserInfo, MenuContent },
	data: () => ({}),
	mounted() {},
	methods: {
		handleSidebar() {
			this.$emit('handleSidebar');
		},
	},
	computed: {
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
		computedClass() {
			return [
				'mobile-sidebar',
				!this.isOpen ? 'closed' : '',
				this.isSafari ? 'safari' : '',
				'mobile-sidebar--env',
			];
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'MobileSidebar.scss';
</style>
